import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Shipping = () => {
  // 🔹 Updated Shipping Content (Professional & ready to use)
  const shippingPolicies = [
    {
      id: 1,
      title: "Order Processing Time",
      delivery_days: "1–2 Days",
      description:
        "All orders are processed within 1–2 business days.\nOrders placed after 5 PM will be processed the next working day.\nDuring sales or high-volume periods, processing may take slightly longer.",
      is_active: 1,
    },
    {
      id: 2,
      title: "Standard Shipping",
      delivery_days: "3–7 Days",
      description:
        "Standard delivery takes between 3 to 7 business days depending on your location.\nOnce dispatched, your tracking details will be shared through SMS and email.",
      is_active: 1,
    },
    {
      id: 3,
      title: "Express Shipping",
      delivery_days: "1–2 Days",
      description:
        "Express shipping ensures delivery within 1–2 business days.\nThis option may include additional charges at checkout.",
      is_active: 1,
    },
    {
      id: 4,
      title: "Shipping Charges",
      delivery_days: "Varies",
      description:
        "Shipping charges are calculated based on weight, location, and selected delivery mode.\nOrders above a specific amount may qualify for free shipping (if applicable).",
      is_active: 1,
    },
    {
      id: 5,
      title: "International Shipping",
      delivery_days: "7–15 Days",
      description:
        "We offer international deliveries to selected countries.\nDelivery timelines range from 7 to 15 business days.\nCustoms duties or import taxes, if applicable, will be borne by the customer.",
      is_active: 0,
    },
    {
      id: 6,
      title: "Order Tracking",
      delivery_days: "Real-Time",
      description:
        "After your order is shipped, a tracking number will be sent to your registered mobile number and email.\nYou can track your shipment status anytime using the tracking link.",
      is_active: 1,
    },
    {
      id: 7,
      title: "Undelivered or Returned Packages",
      delivery_days: "Case-Based",
      description:
        "If a package cannot be delivered due to incorrect address, unavailability, or refusal, it will be returned to us.\nReshipping charges may apply if you request another attempt.",
      is_active: 1,
    },
  ];

  return (
    <>
      <div className="py-5 bg-white">
        <Container>
          <Row>
            <Col md={8}>
              {/* <h2 className="mb-4">Shipping Policies</h2> */}

              {shippingPolicies.map((policy) => (
                <div key={policy.id} className="mb-4 border-bottom">

                  {/* Header */}
                  <div className="p-3">
                    <h5 className="mb-2 text-dark fw-bold">{policy.title}</h5>

                    <div className="d-flex gap-3 mb-2">
                      <span className="text-muted small">
                        Estimated Time:{" "}
                        <strong>{policy.delivery_days}</strong>
                      </span>

                      {/* {policy.is_active === 1 && (
                        <span className="text-success small fw-bold">● Active</span>
                      )} */}
                    </div>
                  </div>

                  {/* Description */}
                  <div className="p-3 bg-white border-top">
                    <p
                      className="mb-0"
                      style={{
                        fontSize: "18px",
                        color: "#313131FF",
                        whiteSpace: "pre-line",
                      }}
                    >
                      {policy.description}
                    </p>
                  </div>
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </div>
      <hr />
    </>
  );
};

export default Shipping;
